import HoverableInfoIcon from './HoverableInfoIcon'

export default HoverableInfoIcon
